import { inject, Pipe, PipeTransform } from "@angular/core";
import { getPhoneNumber } from "src/app/support/phone";
import { hasText } from "src/app/support/text";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";

@Pipe({
  name: "phone",
  standalone: false
})
export class PhonePipe implements PipeTransform {
  private readonly bootstrapService = inject(BootstrapService);

  transform(value: string | undefined): string {
    if (!value || !hasText(value)) {
      return "";
    }

    return getPhoneNumber(value, this.bootstrapService);
  }
}
